import React, { useContext, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader } from 'reactstrap';
import TableContainer from '../../Components/Common/TableContainer';
import { DashboardContext } from '../../context/DashboardContext';
import moment from 'moment';
import 'moment/locale/fa';

const RecentArticleTable = () => {
  const { recentPosts } = useContext(DashboardContext);

  const columns = useMemo(
    () => [
      {
        header: 'شماره',
        accessorKey: 'id',
        enableColumnFilter: false,
        enableSorting: false
      },
      {
        header: 'عنوان پست',
        accessorKey: 'title',
        enableColumnFilter: false,
        cell: (cell) => (
          <>
            <img
              src={`${process.env.REACT_APP_API_BASE_URL}${cell.row.original.image}`}
              alt=""
              className="me-2 rounded"
              height="40"
            />
            <Link to={`/blog/post/${cell.row.original.id}`} className="text-body fw-medium">
              {cell.getValue().length > 50 ? cell.getValue().substring(0, 50) + '...' : cell.getValue()}
            </Link>
          </>
        )
      },
      {
        header: 'تاریخ انتشار',
        accessorKey: 'publishedAt',
        enableColumnFilter: false,
        cell: (cell) => moment(cell.getValue()).locale('fa').format('DD MMMM YYYY')
      },
      {
        header: 'دسته‌بندی',
        accessorKey: 'category',
        enableColumnFilter: false,
        cell: (cell) => (
          <span className="badge bg-success-subtle text-success p-2">{cell.getValue()}</span>
        )
      },
      {
        header: 'نظرات',
        accessorKey: 'commentsCount',
        enableColumnFilter: false,
        cell: (cell) => cell.getValue().toLocaleString('fa-IR')
      }
    ],
    []
  );

  return (
    <React.Fragment>
      <div className="col-xl-4">
        <Card>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">پست‌های اخیر</h4>
          </CardHeader>
          <CardBody>
            <TableContainer
              columns={columns}
              data={recentPosts || []}
              divClass="table-responsive table-card"
              tableClass="table table-hover table-nowrap align-middle mb-0"
              theadClass="table-light"
              trClass="text-muted"
              showPagination={false}
            />
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default RecentArticleTable;